export default function setContext(key, value) {
    window.DD_RUM.onReady(() => window.DD_RUM.setGlobalContextProperty(key, value));
}
